// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard-module__container___3XpyU","controls":"Dashboard-module__controls___1cWaz","table":"Dashboard-module__table___1b1cv"};